module.exports = __webpack_public_path__ + "img/Andrei.afa24fae.jpg";